import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { FaCheckCircle } from "react-icons/fa";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import "./Price.css";
import PricingUpper from "./PricingUpper";
import PriceTab from "./PriceTab";
import Testimonial from "../Home/Testimonial/Testi/Testimonial";

const Price = () => {
  const [perRelaese, setPerRelease] = useState(true);

  return (
    <div className="price_parent">
      <PricingUpper />

      <div className="pricing-cards-section">
        <Container>
          <motion.div 
            className="mini-title"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >PRICING PLANS</motion.div>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            Pricing for <span className="text-gradient">every need</span>
          </motion.h2>

          <motion.div 
            className="pricing-toggle"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <button
              className={perRelaese ? "active" : ""}
              onClick={() => setPerRelease(true)}
            >
              Unlimited Plans
            </button>
            <button
              className={!perRelaese ? "active" : ""}
              onClick={() => setPerRelease(false)}
            >
              Pay Per Release
            </button>
          </motion.div>

          <motion.p 
            className="description"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.3 }}
          >
            Release to 155+ platforms, including Spotify, JioSaavn, Wynk, Apple Music & Youtube and benefit from the best support of any distribution company, period.
          </motion.p>

          <div className="pricing-cards-container" style={{ justifyContent: perRelaese ? 'center' : 'center', maxWidth: perRelaese ? '1000px' : '500px', margin: '0 auto' }}>
            <AnimatePresence mode="wait">
              {perRelaese ? (
                <motion.div 
                  key="unlimited"
                  className="d-flex flex-wrap flex-md-nowrap gap-4 justify-content-center"
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: 20 }}
                  transition={{ duration: 0.3 }}
                >
                  {/* PRO ARTIST CARD */}
                  <div className="pricing-card pro">
                    <span className="pricing-badge">Pro Artist</span>
                    <div className="pricing-price">
                      <span className="strikethrough">₹2,499</span>
                      <span>₹1,499 <span style={{fontSize: '16px', fontWeight: '500', color: 'rgba(255,255,255,0.7)'}}>/ year</span></span>
                    </div>
                    <div className="features-title">Everything in Basic, plus:</div>
                    <ul className="pricing-features">
                      <li><FaCheckCircle /> Unlimited Releases</li>
                      <li><FaCheckCircle /> 150+ Digital Stores</li>
                      <li><FaCheckCircle /> Keep 80% of Your Earnings</li>
                      <li><FaCheckCircle /> Release Within 24 - 48 Hours</li>
                      <li><FaCheckCircle /> On-Demand Royalty Payouts</li>
                      <li><FaCheckCircle /> Royalty Splits at Source</li>
                      <li><FaCheckCircle /> YouTube Content ID
</li>
                      <li><FaCheckCircle /> Music Video Distribution (VEVO, Apple Music & More)
</li><li><FaCheckCircle /> All-in-One Analytics Dashboard

</li>
                    </ul>
                    <a href="https://dashboard.fttunes.com/register.php" rel="noopener noreferrer">
                      <button className="btn-signup">Sign Up</button>
                    </a>
                  </div>

                  {/* RECORD LABEL CARD */}
                  <div className="pricing-card label">
                    <span className="pricing-badge">Record Label</span>
                    <div className="pricing-price">
                      <span className="strikethrough">₹4,999</span>
                      <span>₹2,999 <span style={{fontSize: '16px', fontWeight: '500', color: 'rgba(255,255,255,0.7)'}}>/ year</span></span>
                    </div>
                    <div className="features-title">Everything in Pro, plus:</div>
                    <ul className="pricing-features">
                      <li><FaCheckCircle /> Add Unlimited Artists
</li>
                      <li><FaCheckCircle /> 150+ Digital Stores
</li>
                      <li><FaCheckCircle /> Keep 80% of Royalties
</li>
                      <li><FaCheckCircle /> Analytics Dashboard
</li>
                      <li><FaCheckCircle /> Editorial Playlist Pitching
</li>
                      <li><FaCheckCircle /> FTTunes Social Media & Playlist Promotion
</li>
                      <li><FaCheckCircle />YouTube Official Artist Channel
</li>
                      <li><FaCheckCircle /> YouTube Content ID
</li>
                      <li><FaCheckCircle /> Music Video Distribution (VEVO, Apple Music & More)
</li><li><FaCheckCircle /> Sync Licensing Opportunities

</li>
                    </ul>
                    <a href="https://dashboard.fttunes.com/register.php" rel="noopener noreferrer">
                      <button className="btn-signup">Sign Up</button>
                    </a>
                  </div>
                </motion.div>
              ) : (
                <motion.div 
                  key="pay-per"
                  className="d-flex justify-content-center w-100"
                  initial={{ opacity: 0, x: 20 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: -20 }}
                  transition={{ duration: 0.3 }}
                >
                  {/* ARTIST CARD */}
                  <div className="pricing-card pro" style={{ maxWidth: "450px" }}>
                    <span className="pricing-badge">Artist</span>
                    <div className="pricing-price">
                      <span className="strikethrough">₹4,99/</span>
                      <span>₹299</span>
                    </div>
                    <div className="features-title">What’s included:</div>
                    <ul className="pricing-features">
                      <li><FaCheckCircle /> 150+ Digital Stores
</li>
                      <li><FaCheckCircle /> Keep 80% of Your Earnings
</li>
                      <li><FaCheckCircle />Release Within 24 - 48 Hours
</li>
                      <li><FaCheckCircle />Real-Time Analytics
</li>
                      <li><FaCheckCircle /> Editorial Playlist Pitching
</li>
                      <li><FaCheckCircle /> FTTunes Social Media & Playlist Promotion
</li>
<li><FaCheckCircle /> YouTube Content ID
</li>
    <li><FaCheckCircle /> Dolby Atmos Distribution

</li>
    <li><FaCheckCircle /> Music Video Distribution (VEVO, Apple Music & More)

</li>
    <li><FaCheckCircle /> Sync Licensing Opportunities

</li>
                    </ul>
                    
                    <Link to="/signup">
                      <button className="btn-signup">Sign Up</button>
                    </Link>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        </Container>
      </div>

      <PriceTab />
      <Testimonial />
    </div>
  );
};

export default Price;
